import { fixContentExtraData, inspectContentExtraData } from './fixContentExtraData.js';

/**
 * Script runner to execute the Content Extra data fixes
 * Run this in the browser console to fix the data issues
 */

// Make functions available globally for console use
window.fixContentExtraData = fixContentExtraData;
window.inspectContentExtraData = inspectContentExtraData;

console.log('🛠️ Content Extra fix script loaded!');
console.log('📋 Available functions:');
console.log('  - inspectContentExtraData() - Check current data structure');
console.log('  - fixContentExtraData() - Run the complete fix');
console.log('');
console.log('💡 Usage:');
console.log('  1. First run: await inspectContentExtraData()');
console.log('  2. Then run: await fixContentExtraData()');

// Auto-run inspection on load to show current state
console.log('🔍 Auto-running inspection...');
inspectContentExtraData().catch(console.error);